import React from 'react'
import PropTypes from 'prop-types'

import { Container, Row, Col } from '../../base/Grid'
import Typography from '../../base/Typography'
import Icon from '../../base/Icon'

import { Styles } from './styles'

export const ThankYouComponent = ({
  thankYouText,
  thankYouTextDescription
}) => {
  const styles = Styles()
  return (
    <Container>
      <Row align="center">
        <Col xsmall={12} className={'nmx-align-center'}>
          <Icon variant='profile-outline-checkmark-with-border' />
          <Typography variant="h3" align="center" styles={styles.thankYouText}>
            {thankYouText}
          </Typography>
          {!!thankYouTextDescription && (
            <Typography variant="p" align="center">
              {thankYouTextDescription}
            </Typography>
          )}
        </Col>
      </Row>
    </Container>
  )
}

ThankYouComponent.propTypes = {
  thankYouText: PropTypes.string,
  thankYouTextDescription: PropTypes.string
}

ThankYouComponent.defaultProps = {
  thankYouText: 'Thank you.',
  thankYouTextDescription: null
}

export default ThankYouComponent
